import { useParams } from '@ksyos/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { IReduxState } from '../../../configureStore';
import { QuestionnaireName } from '../../../../common/enums/QuestionnaireName';
import { fetchJson } from '../../../store/fetch';
import { calculateProgressForProgressBar, findCurrentPage } from '../../../utils/questionnaireFunctions';
import { Main } from '../../elements/molecules/main/Main';
import { ProgressBar } from '../../elements/molecules/progressBar/ProgressBar';
import { Header } from '../../elements/organisms/header/Header';
import { PageWrapper } from '../../elements/organisms/pageWrapper/PageWrapper';
import { QuestionnaireForm } from '../questionnaireForm/QuestionnaireForm';
import { OsasEssIntro } from './components/osasEssIntro';
import { OsasHsdqIntro } from './components/osasHsdqIntro';

export function Questionnaire() {
    const params = useParams();

    const [showIntro, setShowIntro] = useState(true);
    const [progress, setProgress] = useState(0);
    const [page, setPage] = useState(1);

    const action = useSelector((state: IReduxState) =>
        state.authentication.actions?.find((item) => item.id === params.actionId)
    );

    const questionnaireName = action?.serviceWorkflowStep.parameters?.questionnaireName;
    const processId = action?.processId;
    const processActivityId = action?.activities?.find((activity) => activity.processActivityId)?.processActivityId;

    useEffect(() => {
        if (questionnaireName && processId) {
            getPatientQuestionnaire();
        }
    }, [questionnaireName, processId]);

    if (!questionnaireName || !processId) {
        return null;
    }

    let component;

    if (showIntro) {
        switch (questionnaireName) {
            case QuestionnaireName.osasEss:
                component = <OsasEssIntro onClick={() => setShowIntro(false)} />;
                break;
            case QuestionnaireName.osasHsdq:
                component = <OsasHsdqIntro onClick={() => setShowIntro(false)} />;
                break;
            default:
                return null;
        }
    } else {
        component = (
            <QuestionnaireForm
                action={action}
                page={page}
                updateProgress={(value: number) => setProgress(value)}
            />
        );
    }

    return (
        <PageWrapper fullHeight>
            <Header
                backButtonText=" "
                backUrl="/osas/questionnaires/"
                hasBackbutton
            />

            <ProgressBar progress={progress}></ProgressBar>
            <Main>{component}</Main>
        </PageWrapper>
    );

    async function getPatientQuestionnaire() {
        if (questionnaireName) {
            let url = `/api/patient/process/${processId}/questionnaire/${questionnaireName}`;
            if (processActivityId) {
                url += `?processActivityId=${processActivityId}`;
            }
            const result = await fetchJson(url, 'GET');

            if (result.json.responseItems.length > 0) {
                setShowIntro(false);
                setProgress(
                    calculateProgressForProgressBar(result.json.questionnaire.items, result.json.responseItems.length)
                );
                setPage(findCurrentPage(questionnaireName, result.json.responseItems.length));
            }
        }
    }
}
